import { Injectable, inject } from '@angular/core';
import {
  Storage,
  ref,
  getStorage,
  uploadString,
  getDownloadURL,
} from '@angular/fire/storage';
@Injectable({
  providedIn: 'root',
})
export class FirebaseUploaderService {
  private readonly storage: Storage = inject(Storage);

  async uploadFileFromBase64(
    dataUrl: string,
    filePath: string
  ): Promise<string> {
    const imageStorageRef = ref(getStorage(), filePath);

    await uploadString(imageStorageRef, dataUrl, 'base64');

    const imageStorageDownloadURL = await getDownloadURL(imageStorageRef);

    return imageStorageDownloadURL;
  }
}
